/**
 * Normalized request state used by any request-backed feature (chart, overview,
 * sparxs metadata, etc.). Enables consistent loading/error/empty UI and
 * optional refetch or rollback via lastFetchedAt / snapshot.
 */
export type RequestStatus = "idle" | "loading" | "success" | "error";

export interface RequestState<T> {
  status: RequestStatus;
  data: T | null;
  error: string | null;
  /** When the failure was an HTTP layer error, the response status (e.g. OpenAPI ajax error). */
  httpStatus?: number;
  lastFetchedAt?: number;
}

export const createInitialRequestState = <T>(
  overrides?: Partial<RequestState<T>>,
): RequestState<T> => ({
  status: "idle",
  data: null,
  error: null,
  ...overrides,
});
